export default "__VITE_ASSET__9aecd01c__"